import { Link } from 'react-router-dom';
import { HeadingDesc } from '../../Headings';
import './floatingBtn.css';

function FloatingBtn() {
  return (
    <Link to="/">
      <div className="floatingBtn">
        <HeadingDesc text={<b>CONSULT A DOCTOR NOW</b>} />
      </div>
    </Link>
  );
}

export default FloatingBtn;
